import { Component } from '@angular/core';
import { AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';
import { ServiceProvider } from '../../providers/service/service';
import { MessageHelper } from '../../providers/helpers/messages';

@IonicPage()
@Component({
  selector: 'page-cobrancas-arquivadas',
  templateUrl: 'cobrancas-arquivadas.html',
})
export class CobrancasArquivadasPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private service: ServiceProvider, private msgHelper: MessageHelper,
    private alertCtrl: AlertController) {
  }

  form: any = {
    type: "",
    status: "",
    search: "",
    search_responsavel: "",
    codigo: "",
    page: 1,
    date_start: "",
    date_end: "",
    forpage: 10,
    is_arquivado: 1,
    check_arquivado : 1
  }

  resultData: any = null;
  urlSearch = "/cobrancas";

  cobrancas = new Array();

  ionViewWillEnter() {
    this.search();
  }

  public search() {
    this.form.page = 1;
    this.getData();
  }

  public backPage() {
    this.form.page = this.form.page - 1;
    this.getData();
  }

  public nextPage() {
    this.form.page = this.form.page + 1;
    this.getData();
  }

  public nextAll() {
    this.form.page = this.resultData.totalPages;
    this.getData();
  }

  public backAll() {
    this.search();
  }

  /**
   * Retorna os dados da API
   */
  private getData() {
    this.resultData = null;
    this.service.postData(this.form, this.urlSearch, false).then(result => {
      this.resultData = result;
      console.log(this.resultData);
      if (this.resultData.result == 0) {
        this.resultData = null;
      } else {
        this.resultData = this.resultData.data;
      }
      console.log(this.resultData);
    }, error => {
      this.msgHelper.showAlert("Opps", error.message);
    });
  }

  transformValor(valor: number, withCurrency: boolean = false) {
    var numero = valor.toFixed(2).split('.');
    numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.');
    if (withCurrency) {
      return "R$" + numero.join(',');
    }
    return numero.join(',');
  }

  /**
   * Abre o link do pagamento
   * @param obj any
   */
  openLink(obj: any) {
    window.open(obj.linkPagamento, "_blank");
  }

  /**
   * Confirma o pagamento da cobrança
   * @param obj any
   */
  public confirm(obj: any) {

    let alert = this.alertCtrl.create({
      title: 'Atenção',
      message: 'Você deseja confirmar o pagamento da cobrança?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Sim',
          handler: () => {
            this.msgHelper.createLoading('crescent', 'Carregando...');
            this.msgHelper.showLoading();

            this.service.postData({ codigo: obj.codigo }, this.urlSearch + "/confirm", false).then(result => {
              this.msgHelper.closeLoading();
              let response: any = result;
              if (response.result == 0) {
                return this.msgHelper.showAlert("Atenção!", response.message);
              }
              this.msgHelper.showAlert("Sucesso!", response.message);
              this.search();
            }, error => {
              this.msgHelper.closeLoading();
              this.msgHelper.showAlert("Opps", error.message);
            });
          }
        }
      ]
    });
    alert.present();
  }

  /**
   * Remove a cobrança do aluno em uma turma especifica
   * @param obj any
   */
  delete(obj: any) {
    let alert = this.alertCtrl.create({
      title: 'Atenção',
      message: 'Você deseja mesmo remover a cobrança do usuário?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => { }
        },
        {
          text: 'Sim',
          handler: () => {
            this.msgHelper.createLoading('crescent', 'Carregando...');
            this.msgHelper.showLoading();

            this.service.postData({ codigo: obj.codigo }, "/cobrancas/delete", false).then(result => {
              this.msgHelper.closeLoading();
              let response: any = result;
              if (response.result == 0) {
                return this.msgHelper.showAlert("Atenção!", response.message);
              }
              this.msgHelper.showAlert("Sucesso!", response.message);
              this.search();
            }, error => {
              this.msgHelper.closeLoading();
              this.msgHelper.showAlert("Opps", error.message);
            });
          }
        }
      ]
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/cobrancas-arquivadas/cobrancas-arquivadas.ts